import React from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';
import styled from 'styled-components';

const AddOrEditLocationFormHeader = styled.h3`
  font-size: 1.25rem;
  padding: 1rem 0px !important;
  background-color: white !important;
`;
const Header = ({ isOpenAddLocation }) => (
  <div>
    {isOpenAddLocation &&
    <AddOrEditLocationFormHeader className="h3-gray">
      <I18N>ssp.address.add.location</I18N>
    </AddOrEditLocationFormHeader>
    }
    {!isOpenAddLocation &&
    <AddOrEditLocationFormHeader className="h3-gray">
      <I18N>eventSubscription.field.location</I18N>
    </AddOrEditLocationFormHeader>
    }
  </div>
);

Header.propTypes = {
  isOpenAddLocation: PropTypes.bool.isRequired,
};

export default Header;
